Ext.define('SA.view.EditViewCheckbox', {
    alias: 'widget.edit-view-checkbox',
    extend: 'SA.view.Checkbox',

    boxLabel: '-',

    cls: 'sa-edit-check-field',
    encodeBoxLabel: false,

    onLabelClick() {
        var eventName = this.isChecked() ? 'uncheck' : 'check';

        this.fireEvent(eventName, this);
    }
});